<ui-section [title]="title">
	<ui-button
		title-action
		(click)="add()"
		size="sm"
		icon="plus"
		label="Add"
		preset="MEDIUM_EMPHASIS"
	>
	</ui-button>
	<div actions class="flex items-center ml-4">
		<span class="font-semibold text-lg">
			<ng-container *ngIf="statementType === statementTypes.FEE">
				{{ totals?.feesTotal + totals?.feesHST | centsToDollars }}
			</ng-container>
			<ng-container *ngIf="statementType === statementTypes.HST">
				{{
					totals?.HSTDisbursementsTotal + totals?.HSTDisbursementsHST
						| centsToDollars
				}}
			</ng-container>
			<ng-container *ngIf="statementType === statementTypes.NON_HST">
				{{ totals?.nonHSTDisbursementsTotal | centsToDollars }}
			</ng-container>
		</span>
	</div>
	<div></div>
	<div section-content class="@container/acount-table">
		<div
			section-content
			class="flex flex-1 flex-col draggable-list draggable-item gap-3"
			cdkDropList
			cdkDragPreview
			(cdkDropListDropped)="drop($event)"
		>
			<div
				cdkDrag
				class="flex flex-1 justify-between"
				cdkDragBoundary=".draggable-list"
				*ngFor="let item of _statements; let i = index; trackBy: statementId"
			>
				<div class="flex flex-1 relative items-center mr-5 group">
					<span class="p">{{ item.parsedDescription }}</span>
					<div
						class="absolute top-0 left-0 w-full h-full flex justify-center items-center rounded-xl bg-white bg-opacity-80 gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
					>
						<ui-button
							preset="EXTRA_LOW_EMPHASIS"
							icon="selector"
							cdkDragHandle
						></ui-button>
						<ui-button
							preset="EXTRA_LOW_EMPHASIS"
							[holdable]="true"
							icon="trash"
							(click)="delete(item)"
							*ngIf="item?.defaultType !== feeDefaultType"
						></ui-button>
						<ui-button
							preset="EXTRA_LOW_EMPHASIS"
							icon="edit"
							(click)="edit(item.id)"
						>
						</ui-button>
						<ui-button
							preset="EXTRA_LOW_EMPHASIS"
							icon="file"
							(click)="viewDocket(item)"
							*ngIf="viewDocketTypes.includes(item?.defaultType)"
							matTooltip="View Docket"
							data-intercom-target="view-docket-summary"
						>
						</ui-button>
					</div>
				</div>

				<div class="flex-shrink-0 w-36">
					<app-input
						type="cents"
						size="small"
						[ngModel]="item.price"
						(debounce)="setPrice(item.id, $event)"
						[startIcon]="ICON.DOLLAR"
						textAlign="right"
						[disabled]="
							(useAllInclusivePrice && item?.defaultType === feeDefaultType) ||
							disabledTypes.includes(item?.defaultType)
						"
						[tabIndex]="tabIndexStart + i"
					></app-input>
				</div>
			</div>
		</div>
		<div *ngIf="deletedStatements?.length > 0" [@openClose]>
			<div class="flex justify-center my-4">
				<app-button
					btn="link"
					(click)="showDeleted = !showDeleted"
					size="small"
					>{{
						!showDeleted ? 'Show deleted items' : 'Hide deleted items'
					}}</app-button
				>
			</div>
			<div
				*ngIf="showDeleted"
				[@openClose]
				class="flex flex-col gap-2 pb-4 border-b border-gray-200"
			>
				<div
					*ngFor="let deleted of deletedStatements"
					class="flex justify-between items-center gap-2"
				>
					<p class="p">
						{{ deleted.parsedDescription }}
					</p>
					<div>
						<ui-button
							preset="MEDIUM_EMPHASIS"
							size="sm"
							(click)="addBack(deleted)"
							label="Recover"
						></ui-button>
					</div>
				</div>
			</div>
		</div>
		<div class="flex items-end justify-between mt-5 mb-3">
			<span class="p">
				Total (<span *ngIf="statementType === statementTypes.NON_HST"
					>Non HST disbursements</span
				><span *ngIf="statementType === statementTypes.HST"
					>HST disbursements</span
				><span *ngIf="statementType === statementTypes.FEE">Legal fees</span>)
			</span>
			<div class="flex flex-col text-right">
				<div *ngIf="statementType === statementTypes.FEE">
					<div>
						+HST({{ hst * 100 }}%) {{ totals?.feesHST | centsToDollars }}
					</div>
					<div class="p mt-5">
						{{ totals?.feesTotal + totals?.feesHST | centsToDollars }}
					</div>
				</div>
				<div *ngIf="statementType === statementTypes.HST">
					<div>
						+HST({{ hst * 100 }}%)
						{{ totals?.HSTDisbursementsHST | centsToDollars }}
					</div>
					<div class="p mt-5">
						{{
							totals?.HSTDisbursementsTotal + totals?.HSTDisbursementsHST
								| centsToDollars
						}}
					</div>
				</div>
				<div *ngIf="statementType === statementTypes.NON_HST">
					<div class="p mt-5">
						{{ totals?.nonHSTDisbursementsTotal | centsToDollars }}
					</div>
				</div>
			</div>
		</div>
	</div>
</ui-section>
